import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { FormInputConfig, AllInputTypes } from '../../../../../../trash/shared/interfaces/form-input-config';
import { FormComponent } from '../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { IUpdateScopeResponse } from '../../dtos/responses/update-scope-response';
import { ICreateScopeResponse } from '../../dtos/responses/create-scope-response';
import { ICreateScopeRequest } from '../../dtos/requests/create-scope.request';
import { IUpdateScopeRequest } from '../../dtos/requests/update-scope.request';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ScopesService } from '../../services/accounts.service';
import { Subscription, tap, catchError, finalize } from 'rxjs';
import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { getIdFormConfig } from '../../../../../../views/pages/adminstration/temp-common/utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-create-update-scope',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, DialogModule, ButtonModule, FormsModule, FormComponent, TranslateModule],
    templateUrl: './create-update-scope.component.html',
    styleUrl: './create-update-scope.component.scss'
})
export class CreateUpdateScopeComponent {
    private subscriptions: Subscription[] = [];

    isLoadingAddEditItem = false;
    form: FormInputConfig[] = [];
    formValues: any = null;
    validationErrors: any = {};
    validationEmit = false;

    constructor(
        private _ScopesService: ScopesService,
        public dataObj: DynamicDialogConfig,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
        private ref: DynamicDialogRef,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        if (this.dataObj?.data?.item) {
            this.formValues = this.dataObj?.data?.item;
        }
        this.initForm();
    }

    // Initialize the form
    initForm() {
        this.form = [
            getIdFormConfig(this.dataObj?.data?.item?.id),
            {
                type: AllInputTypes.Text,
                name: 'name',
                label: this.translate.instant('FORMS.SCOPE_NAME'),
                placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.SCOPE_NAME')}`,
                defaultValue: this.formValues?.englishName,
                isDisable: !this.dataObj?.data?.visible,
                widthClass: 'col-12',
                validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.SCOPE_NAME')}` }]
            }
        ];
    }
    valueChanged(data: any) {
        this.formValues = { ...data };
    }

    onClose(data?: any) {
        this.ref.close(data);
    }
    emitValidation() {
        this.validationEmit = !this.validationEmit;
        this.cdr.detectChanges();
    }

    async submitForm(data: any) {
        this.isLoadingAddEditItem = true;

        // Determine request type
        if (this.formValues?.id) {
            // Handle update request
            const updateData: IUpdateScopeRequest = this.prepareUpdateDataRequest(data);
            const subscription = (await this._ScopesService.update(updateData, this.formValues.id))
                .pipe(
                    tap((res: IUpdateScopeResponse) => {
                        // Process response specific to update
                        this.processAddEditResponse(res, true);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingAddEditItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        } else {
            // Handle create request
            const createData: ICreateScopeRequest = this.prepareCreateDataRequest(data);
            const subscription = (await this._ScopesService.create(createData))
                .pipe(
                    tap((res: ICreateScopeResponse) => {
                        // Process response specific to create
                        this.processAddEditResponse(res, false);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingAddEditItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        }
    }
    private prepareCreateDataRequest(data: any): ICreateScopeRequest {
        return {
            name: data?.name
        };
    }

    private prepareUpdateDataRequest(data: any): IUpdateScopeRequest {
        return {
            name: data?.name
        };
    }
    private processAddEditResponse(response: IUpdateScopeResponse | ICreateScopeResponse, isUpdate: boolean) {
        if (isUpdate) {
            this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('GENERAL.SUCCESSFULLY_UPDATED'));
        } else {
            this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('GENERAL.SUCCESSFULLY_CREATED'));
        }
        this.onClose(true);
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
